module.exports = __webpack_public_path__ + "img/case_02_1.1ff2cf2f.png";